import MetaTags from "react-meta-tags"
import React from "react"
import { Container } from "reactstrap"
import LeadTag from "../../components/Admin/LeadTag"

const LdTag = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Lead Tags | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <LeadTag />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default LdTag
